package one.healthium.paywall.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.paywall.ui.PaywallScreen
import one.healthium.ui.compose.utils.TargetPlatform
import one.healthium.ui.compose.utils.targetPlatform

@Composable
fun PaywallContent(
    component: PaywallComponent
) {
    if (targetPlatform() == TargetPlatform.Web) return

    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        PaywallScreen(
            paywallId = component.paywallId,
            onboardingId = component.onboardingId,
            eventDelegate = component,
        )
    }
}
